// extracted by mini-css-extract-plugin
export default {"footer":"index_footer_CwVbi","footerInner":"index_footerInner_F2Das","logo":"index_logo_eyk7E"};